import React, { useEffect, useState, useRef } from "react";
import "../style/Navbar.css";
import { Link } from "react-router-dom";
import Logo from "../assets/White_Logo.png";
import Navicon from "../assets/Navicon.png";
import PlusCircle from "../assets/Plus-circle.svg";
import defaultAvatar from "../assets/OIP.jpg";
import Navpage from "../Component/Navpage.jsx";
import SearchBar from "./SearchBar";
import name from "../assets/tagname.png"
// SVG for search icon
const SearchIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className="search-icon"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const Navbar = () => {
  const [userToken, setUserToken] = useState(sessionStorage.getItem("token") || "");
  const [userAvatar, setUserAvatar] = useState(sessionStorage.getItem("userAvatar") || defaultAvatar);
  const [showSide, setShowSide] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const mobileSearchRef = useRef(null);
  const searchIconRef = useRef(null);

  useEffect(() => {
    const handleStorageChange = () => {
      setUserAvatar(sessionStorage.getItem("userAvatar") || defaultAvatar);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    // Add click-away listener for mobile search
    const handleClickOutside = (event) => {
      if (
        showMobileSearch && 
        mobileSearchRef.current && 
        !mobileSearchRef.current.contains(event.target) &&
        searchIconRef.current && 
        !searchIconRef.current.contains(event.target)
      ) {
        setShowMobileSearch(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMobileSearch]);

  const click = () => {
    //code to make navpage component appear
    console.log("Navicon clicked!");
    // If opening sidebar, close mobile search if it's open
    if (!showSide && showMobileSearch) {
      setShowMobileSearch(false);
    }
    setShowSide((prevState) => !prevState);
  }

  const toggleMobileSearch = () => {
    // Don't allow opening search if sidebar is open
    if (showSide && !showMobileSearch) {
      return;
    }
    setShowMobileSearch(prev => !prev);
  };

  useEffect(() => {
    if (userToken) {
      fetch(`${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem("user")}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.attributes && data.attributes.picture) {
            const profileImage = data.attributes.picture;
            setUserAvatar(profileImage);
            sessionStorage.setItem("userAvatar", profileImage);
          }
        })
        .catch((error) => {
          console.error("Error fetching user profile image:", error);
        });
    }
  }, [userToken]);

  return (
    <>
      <header className="navbar">
        <div className="navbar-left">
          <img className="navicon" src={Navicon} alt="Logo" onClick={click}/>
          {showSide && <Navpage />}
          
          <Link to="/">
            <img className="navbar-icon-button" src={Logo} alt="Logo" />
          </Link>
          <img  className="nametag" src={name} alt=" Sitename: Delish. May the last dish stand!"/>
        </div>

        {/* Desktop search */}
        <div className="navbar-center">
          <SearchBar />
        </div>

        <div className="navbar-right">
          {/* Mobile search icon */}
          <div 
            className={`mobile-search-icon ${showSide ? 'disabled' : ''}`} 
            onClick={toggleMobileSearch}
            ref={searchIconRef}
          >
            <SearchIcon />
          </div>

          {!userToken ? (
            <div className="auth_space">
              <Link to="/login">
                <button className="log">Login</button>
              </Link>
              <Link to="/signup">
                <button className="sign">Sign Up</button>
              </Link>
            </div>
          ) : (
            <>
            <div className="log-right">
              <Link to="/review">
                <img className="plus-circle" src={PlusCircle} alt="Plus Circle" />
              </Link>
              <Link to="/Self">
                <img
                  className="navbar-avatar"
                  alt="User Avatar"
                  src={userAvatar}
                  onError={(e) => {
                    e.target.src = defaultAvatar;
                  }}
                  style={{ width: "35px", height: "35px", marginLeft: "15px", borderRadius: "50%" }}
                />
              </Link>
              </div>
            </>
          )}
        </div>
      </header>
      
      {/* Mobile search container - slides down when active */}
      <div 
        className={`mobile-search-container ${showMobileSearch ? 'active' : ''}`}
        ref={mobileSearchRef}
      >
        <div className="mobile-search-wrapper">
          <SearchBar />
        </div>
      </div>
    </>
  );
};

export default Navbar;
